export default __webpack_public_path__ + "static/media/roadmap-m-4.3f79cf47.png";